import { motion } from "framer-motion"
import { FiFilter } from "react-icons/fi"
import { useLanguage } from "../contexts/LanguageContext"

const EmptyStateComponent = ({ darkMode, filteredProducts, secondaryTextColor }) => {
  const { t } = useLanguage()

  return (
    <>
      {filteredProducts?.length === 0 && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="text-center py-16" >
          <FiFilter className={`text-6xl ${darkMode ? "text-gray-600" : "text-gray-400"} mx-auto mb-4`} />
          <h3 className="text-2xl font-bold mb-2">{t("no_products_found")}</h3>
          <p className={secondaryTextColor}>{t("adjust_filters")}</p>
        </motion.div>
      )}
    </>
  )
}

export default EmptyStateComponent
